import { Suspense, useEffect, useState } from "react";
import { useValidadorAsientosContablesContext } from "../../../../context/validadorAsientosContablesContext";
import { Grid2, Typography, Box } from "@mui/material";

function formatDateToDDMMYYYY(date: string) {
  const [year, month, day] = date.split('-');
  return `${day}-${month}-${year}`;
}

function ResumenFiltrosComponent() {

    const { formFilters } = useValidadorAsientosContablesContext();

    const [fechaInicioFormateada, setFechaInicioFormateada] = useState<string>('');
    const [fechaFinFormateada, setFechaFinFormateada] = useState<string>('');

    useEffect(() => {
        if( !formFilters?.fechaFin ) return;

        const fechaInicioISO = formFilters?.fechaInicio!.toISOString().split("T")[0];
        const fechaFinISO = formFilters?.fechaFin!.toISOString().split("T")[0];
        setFechaInicioFormateada(formatDateToDDMMYYYY(fechaInicioISO!));
        setFechaFinFormateada(formatDateToDDMMYYYY(fechaFinISO!));

    }, [formFilters]);

    return (
        <Suspense fallback={<div>Cargando resumen...</div>}>
            <Grid2 container spacing={1} sx={{ mb: 2 }}  >
                <Grid2 size={3}>
                    <Typography variant="subtitle2" color="text.secondary">
                        Periodo:
                    </Typography>
                    <Typography variant="body1" fontWeight="bold" color="text.primary">
                        {fechaInicioFormateada} al {fechaFinFormateada}
                    </Typography>
                </Grid2>

                <Grid2 size={4} />
            
                <Grid2 size={2}>
                    <Typography variant="subtitle2" color="text.secondary">
                        Acción:
                    </Typography>
                    <Typography variant="body1" fontWeight="bold" color="text.primary">
                        {formFilters?.codigoAccion || ''}
                    </Typography>
                </Grid2>
            
                <Grid2 size={2}>
                    <Typography variant="subtitle2" color="text.secondary">
                        N° de Operación
                    </Typography>
                    <Typography variant="body1" fontWeight="bold" color="text.primary">
                        {formFilters?.numeroOperacion || ''}
                    </Typography>
                </Grid2>
            
        </Grid2>
        </Suspense>
    );
}

export default ResumenFiltrosComponent;
